import { Fab, Tooltip, Zoom, useScrollTrigger } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WhatsappIcon } from './WhatsappIcon';
import { whatsappLink } from '@/lib/whatsapp';
import { usePublicContent } from '@/features/home/use-public-content';

/**
 * Floating click-to-chat button. Appears once the visitor scrolls past the
 * hero, so it never competes with the primary call to action.
 */
export function WhatsappFab() {
  const { t } = useTranslation();
  const { settings } = usePublicContent();
  const visible = useScrollTrigger({ disableHysteresis: true, threshold: 400 });

  return (
    <Zoom in={visible}>
      <Tooltip title={t('contact.whatsappUs')} placement="left">
        <Fab
          component="a"
          href={whatsappLink(settings['company.whatsapp'], t('contact.whatsappDraft'))}
          target="_blank"
          rel="noopener"
          aria-label={t('contact.whatsappUs')}
          sx={{
            position: 'fixed',
            right: { xs: 16, md: 28 },
            bottom: { xs: 16, md: 28 },
            zIndex: (theme) => theme.zIndex.appBar - 1,
            bgcolor: 'text.primary',
            color: 'background.default',
            '&:hover': { bgcolor: 'text.secondary' },
          }}
        >
          <WhatsappIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}
